/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-05-15 14:37:23
 * @LastEditors: changfeng
 * @LastEditTime: 2024-09-09 19:58:20
 */
export default {
	"subscription.intro.title": "Select your plan",
	"subscription.intro.subtitle": "Discover the perfect AdSurgebot plan tailored to your unique advertising needs.",
	"subscription.intro.subtitle1":
		"After charged the monthly subscription fee，you will get a 7-day free trial. You can cancel your subscription and request a refund within a 7-day trial period at any time.",
	"subscription.intro.button.currentPlan": "CURRENT PLAN",

	"subscription.intro.standard.title": "Standard",
	"subscription.intro.standard.timeUnits": "month",
	"subscription.intro.standard.item1": "Unlimited profiles",
	"subscription.intro.standard.item2": "30 accounts connected",
	"subscription.intro.standard.item3": "20 automated rules with 10 ad accounts",
	"subscription.intro.standard.item4": "Create and manage ads in minutes",
	"subscription.intro.standard.item5": "Up to 5 seats for your team",
	"subscription.intro.standard.item6": "Clear and intuitive dashboard data",
	"subscription.intro.standard.item7": "Rules run every 10 minutes",
	"subscription.intro.standard.item8": "Provide technical support via Email during weekdays",
	"subscription.intro.standard.button": "Choose Standard",

	"subscription.intro.professional.title": "Professional",
	"subscription.intro.professional.timeUnits": "month",
	"subscription.intro.professional.item1": "Unlimited profiles",
	"subscription.intro.professional.item2": "50 accounts connected",
	"subscription.intro.professional.item3": "50 automated rules with 20 ad accounts",
	"subscription.intro.professional.item4": "Create and manage ads in minutes",
	"subscription.intro.professional.item5": "Up to 20 seats for your team",
	"subscription.intro.professional.item6": "Clear and intuitive dashboard data",
	"subscription.intro.professional.item7": "Rules run every 5 minutes",
	"subscription.intro.professional.item8": "Provide technical support via WeChat during weekdays",
	"subscription.intro.professional.button": "Choose Professional",
	"subscription.intro.professional.mostPopular": "Most Popular",

	"subscription.intro.business.title": "Professional",
	"subscription.intro.business.timeUnits": "month",
	"subscription.intro.business.item1": "Unlimited profiles",
	"subscription.intro.business.item2": "Unlimited accounts connected",
	"subscription.intro.business.item3": "Unlimited automated rules with unlimited ad accounts",
	"subscription.intro.business.item4": "Create and manage ads in minutes",
	"subscription.intro.business.item5": "Up to unlimited seats for your team",
	"subscription.intro.business.item6": "Clear and intuitive dashboard data",
	"subscription.intro.business.item7": "Rules run every 1 minute",
	"subscription.intro.business.item8": "Provide 7*24h technical support",
	"subscription.intro.business.button": "Contact Us",

	"subscription.intro.footer.text":
		"After charged the monthly subscription fee，you will get a 7-day free trial. You can cancel your subscription and request a refund within a 7-day trial period at any time.",

	"subscription.upgrade.modal.title": "Upgrade Plan",
	"subscription.upgrade.modal.text": "Are you sure you want to upgrade to the Professional Plan？",
	"subscription.upgrade.modal.ok": "Upgrade Plan",

	"subscription.referrals.title": "Referrals",
	"subscription.referrals.left.title": "Share your referral link with others",
	"subscription.referrals.left.intro": "Send your link to a friend to earn $5 when they upgrade using their $5 credit",
	"subscription.referrals.left.button": "Copy referral link",
	"subscription.referrals.left.button.success": "subscription.referrals.left.button.success",
	"subscription.referrals.right.title": "Rewards",
	"subscription.referrals.right.intro": "Total credit earned",
	"subscription.paurches.modal.sub":
		"For your first purchase, you will get a 7-day free trial. You can cancel your subscription and request a refund within a 7-day trial period.",
	"subscription.skip to billing": "Skip to Billing"
};
